import { TaxRate } from "../types/taxRates";

/**
 * Formats a tax rate fraction as a percentage, e.g. 0.0625 → "6.250%".
 * Three decimals match how rates are entered (Settings → Taxes) and shown on
 * receipts / checkout.
 */
export const formatTaxRatePercent = (rate: number): string =>
  `${(rate * 100).toFixed(3)}%`;

/**
 * True when the rate has not been end-dated in the past. Rates with an
 * `effective_end_date` on or before today no longer apply to new sales, so
 * pickers and read-only displays hide them.
 */
export const isTaxRateCurrent = (
  rate: Pick<TaxRate, "effective_end_date">,
  today: Date = new Date(),
): boolean =>
  !rate.effective_end_date || new Date(rate.effective_end_date) > today;
